import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const LineStroke = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="m11.134 21.596.142-.866c.034-.259.07-.66-.032-.915-.112-.282-.555-.428-.88-.5C5.557 18.674 2 15.274 2 11.214 2 6.684 6.486 3 12 3s10 3.684 10 8.213c0 1.812-.694 3.444-2.143 5.053-2.098 2.444-6.79 5.42-7.857 5.876-1.037.442-.918-.25-.87-.523m.004-.023-.004.023m.004-.023a2.245 2.245 0 0 1-.004.023"
        stroke="currentColor"
        strokeWidth={1.5}
        fill={"none"}
      />
      <Path
        d="M8.277 12.712H6.371V9.214a.196.196 0 0 0-.194-.197h-.702a.196.196 0 0 0-.194.197v4.404c0 .107.086.197.194.197h2.802a.196.196 0 0 0 .195-.197v-.709a.196.196 0 0 0-.195-.197ZM9.968 9.017h-.701a.196.196 0 0 0-.195.197v4.405c0 .108.087.196.195.196h.701a.196.196 0 0 0 .195-.196V9.214a.196.196 0 0 0-.195-.197ZM14.796 9.017h-.701a.196.196 0 0 0-.195.197v2.617l-1.997-2.726a.201.201 0 0 0-.162-.088h-.701a.196.196 0 0 0-.195.197v4.405c0 .108.087.196.195.196h.701a.196.196 0 0 0 .195-.196v-2.617l2 2.73a.197.197 0 0 0 .159.083h.701a.196.196 0 0 0 .195-.196V9.214a.196.196 0 0 0-.195-.197ZM18.67 10.12a.195.195 0 0 0 .194-.197v-.709a.196.196 0 0 0-.194-.197h-2.802a.197.197 0 0 0-.195.197v4.404c0 .107.087.197.194.197h2.803a.196.196 0 0 0 .194-.197v-.709a.196.196 0 0 0-.194-.197h-1.906v-.744h1.906a.196.196 0 0 0 .194-.197v-.71a.196.196 0 0 0-.194-.196h-1.906v-.745h1.906Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default LineStroke;
